/**
 * Scroll-in reveals - decides WHEN an element is revealed. The hidden state,
 * the keyframe and the opt-in lists live in assets/theme-reveal.css; read the
 * comment at the top of that file first.
 *
 * REVEAL_SELECTORS below must stay in step with the two opt-in lists in the
 * stylesheet. An element styled there but not observed here would never get
 * .revealed, and would sit at opacity 0 permanently.
 */
(function () {
    var REVEAL_SELECTORS = [
        /* List A - reveals as one unit. Homepage. */
        '.collFeat',
        '.homeChooseRight',
        '.prodDispLsSwiper',
        '.pdpSlideSwiper',
        '.fbspot-copy',
        '.homeProdReviews',
        /* List A - product pages. Each display section renders either a swiper
           or a grid depending on its `grid` setting, so both are listed. */
        '.prodDispSwiper',
        '.prodDispGrid',
        '.accDispSwiper',
        '.accDispGrid',
        '.pdpBundlesSwiper',
        '.pdpFeatTopSwiper',
        /* List B - children cascade */
        '.homeDesignedForContainer',
        '.homeUsefulFeaturesContainer',
        '.homePlacementGrid'
    ].join(',');

    /* Fires once the element's top edge has come up past 85% of the viewport
       height - i.e. the block is properly on screen rather than just peeking.
       The legacy per-section code used a flat -50px, which on a full-bleed band
       meant the animation was over before you had really seen it.

       A percentage rather than a pixel value so the trigger scales with the
       viewport instead of firing proportionally earlier on a tall screen.
       This is the one knob for reveal timing across the whole site. */
    var ROOT_MARGIN = '0px 0px -15% 0px';

    var root = document.documentElement;

    /* Tells the failsafe in layout/theme.liquid that the reveal system is
       alive, so it stops counting down to un-hiding everything. */
    root.dataset.revealReady = 'true';

    if (!('IntersectionObserver' in window)) {
        root.classList.remove('reveal-enabled');
        return;
    }

    function reveal(element) {
        element.classList.add('revealed');
        // One-shot: a revealed element never hides again on scroll back.
        observer.unobserve(element);
    }

    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                reveal(entry.target);
                return;
            }

            /* Not intersecting can also mean the element is ABOVE the viewport
               and we never saw it enter - which happens whenever the browser
               restores a scroll position on reload, or a link lands on an
               anchor further down the page. Without this it would stay at
               opacity 0 forever, because it will never scroll into the trigger
               zone from below. */
            if (entry.boundingClientRect.bottom < 0) reveal(entry.target);
        });
    }, {rootMargin: ROOT_MARGIN, threshold: 0});

    function observe(scope) {
        var within = (scope && scope.querySelectorAll) ? scope : document;

        if (within.matches && within.matches(REVEAL_SELECTORS)) {
            observer.observe(within);
        }

        within.querySelectorAll(REVEAL_SELECTORS).forEach(function (element) {
            if (!element.classList.contains('revealed')) observer.observe(element);
        });
    }

    observe(document);

    /* The theme editor swaps section markup in after load. Newly rendered
       markup needs observing too, or the merchant edits a setting and watches
       the section vanish. This listener is on document, which is never
       replaced, so it survives the swap. */
    document.addEventListener('shopify:section:load', function (event) {
        observe(event.target);
    });
})();